import React from "react";
import "./Servicos.css";

function Servicos() {
  const itens = [
    {
      titulo: "Sites Profissionais",
      texto:
        "Desenvolvimento de sites estratégicos, modernos, rápidos e focados em conversão.",
    },
    {
      titulo: "Integração com IA",
      texto:
        "Implementação de automações inteligentes, chatbots e ferramentas de IA para seu negócio.",
    },
    {
      titulo: "Banco de Dados",
      texto:
        "Estruturação, criação e gerenciamento de bancos de dados seguros e escaláveis.",
    },
    {
      titulo: "Google Meu Negócio",
      texto:
        "Configuração profissional para aumentar a visibilidade da sua empresa no Google.",
    },
    {
      titulo: "Otimização SEO",
      texto:
        "Técnicas avançadas de SEO para melhorar o ranqueamento do seu site nos buscadores.",
    },
    {
      titulo: "Identidade Visual",
      texto:
        "Criação de identidade visual profissional para fortalecer sua marca no digital.",
    },
  ];

  return (
    <section className="servicos" id="servicos">
      <h1 className="servicos-titulo">
        Como nossas soluções digitais podem transformar o seu negócio?
      </h1>

      <div className="servicos-grid">
        {itens.map((item, index) => (
          <div className="servico-card" key={index}>
            <h2>{item.titulo}</h2>
            <p>{item.texto}</p>
            <span className="linha"></span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Servicos;
